module.exports = __webpack_public_path__ + "media/newstyle/images/idioma-33-14ccd007abe8b7d9b53af7feab7e9c8a.png";